import { render, staticRenderFns } from "./filekind-setting.vue?vue&type=template&id=55bd7286&scoped=true&"
import script from "./filekind-setting.vue?vue&type=script&lang=js&"
export * from "./filekind-setting.vue?vue&type=script&lang=js&"
import style0 from "./filekind-setting.vue?vue&type=style&index=0&id=55bd7286&prod&scoped=true&lang=css&"
import style1 from "./filekind-setting.vue?vue&type=style&index=1&id=55bd7286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd7286",
  null
  
)

export default component.exports